import NoteContext from './noteContext';
import { useState } from 'react';

const NoteState = (props) => {
  const host = "https://inotebook-backend-urbn.onrender.com"
  //Value of the state in object form
  const notesInitial =
    []

  const [notes, setNotes] = useState(notesInitial)

  //GET a Notes
  const getNotes = async () => {

    //API Call

    const response = await fetch(`${host}/api/notes/fetchallnotes`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'auth-token': localStorage.getItem('token')
      }
    });
    const json = await response.json()
    if (json.success) {
      setNotes(json.notes)
    }
    else {
      console.log(json.error);
    }
  }


  //Add a Note
  const addNote = async (title, description, tag) => {

    //API Call

    const response = await fetch(`${host}/api/notes/addnotes`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'auth-token': localStorage.getItem('token')
      },
      body: JSON.stringify({ title, description, tag })
    });
    const note = await response.json()
    setNotes(notes.concat(note))
  }

  //Delete a Note
  const deleteNote = async (id) => {
    try {

      const response = await fetch(`${host}/api/notes/deletenote/${id}`, {
        method: 'DELETE',
        headers: {
          'Content-Type': 'application/json',
          'auth-token': localStorage.getItem('token')
        }
      });
      const json = await response.json()
      if (json) {
        // deleting the note from frontend too
        const newNotes = notes.filter((note) => { return note._id !== id })
        setNotes(newNotes)
      }
    } catch (error) {
      console.log("Error occured with : ",error);
    }
  }

  //Edit a Note
  const editNote = async (id, title, description, tag) => {
    try {
      //API Call
      const response = await fetch(`${host}/api/notes/updatenote/${id}`, {
        method: 'PUT',
        headers: {
          'Content-Type': 'application/json',
          'auth-token': localStorage.getItem('token')
        },
        body: JSON.stringify({ title, description, tag })
      });
      let json = await response.json()
      if (json) {
        let newNotes = JSON.parse(JSON.stringify(notes));
        //Logic to edit in client
        for (let index = 0; index < newNotes.length; index++) {
          const element = newNotes[index];
          if (element._id === id) {
            newNotes[index].title = title;
            newNotes[index].description = description;
            newNotes[index].tag = tag;
            break;
          }
        }
        setNotes(newNotes);
      }
    } catch (error) {
      console.log("Error occured with : ",error);
    }
  }

  //Return the value to the component which requests for it
  return (
    <NoteContext.Provider value={{ notes, addNote, deleteNote, editNote, getNotes }}>
      {props.children}
    </NoteContext.Provider>
  )
}


export default NoteState;